import { render, staticRenderFns } from "./alunos-distribuicao-kit.vue?vue&type=template&id=39c643fa"
import script from "./alunos-distribuicao-kit.vue?vue&type=script&lang=js"
export * from "./alunos-distribuicao-kit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports